<template>
  <div>
    <h3 class="text-lg font-medium pb-[24px] lg1024:text-xl">
      {{ $t('delivery_services') }}
    </h3>
    <div class="delivery_services">
      <ListRadio
        :list="services"
        :selected="selectedId"
        @callback="(id) => $emit('change', id)"
      />
    </div>

    <div v-if="showDeNotify" class="grayHolder px-4 pt-2 pb-1 mt-1">
      <div class="flex justify-start basket-row">
        <div class="icon mr-1">
          <ExclamationAlertIcon color="#333F48BF" topPosition="2" />
        </div>
        <div class="txt text-xs">{{ $t('workingDays_notify') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ListRadio from '@/components/ListRadio.vue'

defineProps({
  services: { type: Array, default: () => [] },
  selectedId: { type: String, default: '' },
  showDeNotify: { type: Boolean, default: false },
})

defineEmits(['change'])
</script>
